import * as ReactService from "@intech/react-service";
import { ContrachequeEntidade } from "../entidades/ContrachequeEntidade";

class FichaFinanceiraAssistido extends ReactService.BaseService {
  constructor() {
    super("FichaFinanceiraAssistido");
  }

  BuscarUltimaPorPlanoProcesso = (cdPlano: string, cdEspecie: string, ano: string, num: number) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarUltimaPorPlanoProcesso/${cdPlano}/${cdEspecie}/${ano}/${num}`);

  BuscarDatas = () =>
    this.CreateRequest<ContrachequeEntidade[]>(ReactService.RequestType.GET, `BuscarDatas`);

  BuscarPorPlanoReferenciaTipoFolhaEspecie = (cdPlano: string, referencia: string, cdTipoFolha: string, cdEspecie: string) =>
    this.CreateRequest<ContrachequeEntidade>(ReactService.RequestType.GET, `BuscarPorPlanoReferenciaTipoFolhaEspecie/${cdPlano}/${referencia}/${cdTipoFolha}/${cdEspecie}`);

  BuscarPorPlanoReferenciaTipoFolhaPrevia = (cdPlano: string, referencia: string, cdTipoFolha: string) =>
    this.CreateRequest<ContrachequeEntidade>(ReactService.RequestType.GET, `BuscarPorPlanoReferenciaTipoFolhaPrevia/${cdPlano}/${referencia}/${cdTipoFolha}`);

  GerarRelatorio = (cdPlano: string, referencia: string, cdTipoFolha: string, cdEspecie: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorio/${cdPlano}/${referencia}/${cdTipoFolha}/${cdEspecie}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GerarRelatorioPrevia = (cdPlano: string, referencia: string, cdTipoFolha: string, cdEspecie: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorioPrevia/${cdPlano}/${referencia}/${cdTipoFolha}/${cdEspecie}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const FichaFinanceiraAssistidoService = new FichaFinanceiraAssistido();
